import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './lib/theme.jsx';
import CheckoutPage from './pages/checkout/CheckoutPage.jsx';
import PaymentLinkPage from './pages/checkout/PaymentLinkPage.jsx';
import CheckoutNotFound from './pages/checkout/CheckoutNotFound.jsx';

/**
 * US-1: "A customer must never be asked to register, log in, or install
 * anything. A checkout link is the entire customer experience."
 *
 * There is no AuthProvider here and no session of any kind — deliberately.
 * DP-2 serves this on its own hostname, so the dashboard's refresh cookie is
 * never even sent to these routes.
 */
export function CheckoutApp() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>
          <Route path="/c/:sessionId" element={<CheckoutPage />} />
          <Route path="/l/:code" element={<PaymentLinkPage />} />
          <Route path="/" element={<Navigate to="/not-found" replace />} />
          <Route path="*" element={<CheckoutNotFound />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default CheckoutApp;
